import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
import { SchoolService } from "../../../shared/services/school.service";
//Import Custom Services Here
import { StartMonthService } from "../report-services/start-month.service";
import { StartYearService } from "../report-services/start-year.service";
import { EndMonthService } from "../report-services/end-month.service";
import { EndYearService } from "../report-services/end-year.service";
import { InfractionLevelService } from "../report-services/infraction-level.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";

@Component({
	templateUrl: "./incidentsbymonthinfractionlevel.component.html",
})
export class IncidentsbyMonthInfractionLevelComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private schoolService: SchoolService,
		//Insert Custom Services Here
		private infractionlevelService: InfractionLevelService,
		private endyearService: EndYearService,
		private endmonthService: EndMonthService,
		private startyearService: StartYearService,
		private startmonthService: StartMonthService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		SchoolXML: "",
		StartMonthID: 0,
		StartYearID: 0,
		EndMonthID: 0,
		EndYearID: 0,
		InfractionLevelID: 0,
		ShowDetailID: "Yes",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	schoolList: any = [];
	StartMonthList: any = [];
	StartYearList: any = [];
	EndMonthList: any = [];
	EndYearList: any = [];
	InfractionLevelList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 332;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist();
		// this.loadStartMonthList()
		// this.loadStartYearList()
		// this.loadEndMonthList()
		// this.loadEndYearList()
		// this.loadInfractionLevelList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadStartMonthList();
		this.loadStartYearList();
		this.loadEndMonthList();
		this.loadEndYearList();
		this.loadInfractionLevelList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(332);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					this.loadStartMonthList();
					this.loadStartYearList();
					this.loadEndMonthList();
					this.loadEndYearList();
					this.loadInfractionLevelList();
				}
			},
			(error) => {}
		);
	}

	private loadStartMonthList() {
		this.report.StartMonthID = 0;
		var result = this.startmonthService.loadStartMonthList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.StartMonthList = response;

				if (this.StartMonthList.length > 1) {
					this.StartMonthList.unshift({
						MonthID: 0,
						MonthDesc: "All Start Months",
					});
				} else {
					this.report.StartMonthID = this.StartMonthList[0].StartMonthID;
				}
			},
			(error) => {}
		);
	}

	private loadStartYearList() {
		this.report.StartYearID = 0;
		var result = this.startyearService.loadStartYearList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.StartYearList = response;

				if (this.StartYearList.length > 1) {
					this.StartYearList.unshift({
						YearID: 0,
						YearDesc: "All Start Years",
					});
				} else {
					this.report.StartYearID = this.StartYearList[0].StartYearID;
				}
			},
			(error) => {}
		);
	}

	private loadEndMonthList() {
		this.report.EndMonthID = 0;
		var result = this.endmonthService.loadEndMonthList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.EndMonthList = response;

				if (this.EndMonthList.length > 1) {
					this.EndMonthList.unshift({
						MonthID: 0,
						MonthDesc: "All End Months",
					});
				} else {
					this.report.EndMonthID = this.EndMonthList[0].EndMonthID;
				}
			},
			(error) => {}
		);
	}

	private loadEndYearList() {
		this.report.EndYearID = 0;
		var result = this.endyearService.loadEndYearList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.EndYearList = response;

				if (this.EndYearList.length > 1) {
					this.EndYearList.unshift({
						YearID: 0,
						YearDesc: "All End Years",
					});
				} else {
					this.report.EndYearID = this.EndYearList[0].EndYearID;
				}
			},
			(error) => {}
		);
	}

	private loadInfractionLevelList() {
		this.report.InfractionLevelID = 0;
		var result = this.infractionlevelService.loadInfractionLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InfractionLevelList = response;

				this.report.InfractionLevelID = this.InfractionLevelList[0].InfractionLevelID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolXML) {
		// 	this.errorMessage = "Select the SchoolXML"
		// 	return;
		// }

		if (!this.report.StartMonthID) {
			this.errorMessage = "Select the Start Month";
			return;
		}

		if (!this.report.StartYearID) {
			this.errorMessage = "Select the Start Year";
			return;
		}

		if (!this.report.EndMonthID) {
			this.errorMessage = "Select the End Month";
			return;
		}

		if (!this.report.EndYearID) {
			this.errorMessage = "Select the End Year";
			return;
		}

		// if (!this.report.InfractionLevelID) {
		// 	this.errorMessage = "Select the InfractionLevel"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 332;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolXML
		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>" + "|SchoolXML";

		//Parameter 2: StartMonthID
		strParam += "," + this.report.StartMonthID + "|StartMonthID";

		//Parameter 3: StartYearID
		strParam += "," + this.report.StartYearID + "|StartYearID";

		//Parameter 4: EndMonthID
		strParam += "," + this.report.EndMonthID + "|EndMonthID";

		//Parameter 5: EndYearID
		strParam += "," + this.report.EndYearID + "|EndYearID";

		//Parameter 6: InfractionLevelID
		strParam += "," + this.report.InfractionLevelID + "|InfractionLevelID";

		//Parameter 7: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
